import { isJSON } from "@/util/utils";
import { platformInspectionTypeLabel } from "@/util/platformInspectionType";
import { absReportAssetUrl, assetUrlList } from "@/util/reportAssetUrl";

/** 商品图：支持 JSON { img, packImg } 或单 URL */
export function productImageUrls(row) {
  if (!row || !row.productImage) return [];
  const raw = row.productImage;
  if (typeof raw === "string" && isJSON(raw)) {
    try {
      const obj = JSON.parse(raw);
      const urls = [];
      if (obj && obj.img) urls.push(absReportAssetUrl(obj.img));
      if (obj && obj.packImg) urls.push(absReportAssetUrl(obj.packImg));
      return urls.filter(Boolean);
    } catch (e) {
      return [];
    }
  }
  if (typeof raw === "string" && (raw.indexOf("http") === 0 || raw.indexOf("/") === 0)) {
    const u = absReportAssetUrl(raw);
    return u ? [u] : [];
  }
  return [];
}

export function brandDisplay(row) {
  if (!row) return "";
  const cn = row.brandName || (row.brand && row.brand.name) || "";
  const en = row.brandEnglishName || (row.brand && row.brand.englishName) || "";
  if (cn && en) return cn + " - " + en;
  return cn || en || "";
}

export function typeDisplay(row) {
  if (!row) return "";
  const cn = row.typeName || (row.type && row.type.name) || "";
  const en = row.typeEnglishName || (row.type && row.type.englishName) || "";
  if (cn && en) return cn + " - " + en;
  return cn || en || "";
}

/** 实物图 / 瑕疵图 JSON 解析为 URL 数组 */
export function parsePictureUrls(raw) {
  if (!raw) return [];
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!parsed) return [];
    if (Array.isArray(parsed)) return assetUrlList(parsed.filter(Boolean));
    if (typeof parsed === "object") {
      return assetUrlList(Object.values(parsed).filter((v) => v));
    }
  } catch (e) {
    /* ignore */
  }
  return [];
}

export function formatInspectionDateTime(val) {
  if (!val) return "-";
  const d = new Date(val);
  if (isNaN(d.getTime())) {
    if (typeof val === "string") return val.substring(0, 19);
    return val;
  }
  const pad = (n) => (n < 10 ? "0" + n : n);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function sffzLabel(sffz) {
  if (sffz == null || sffz === "") return "-";
  return Number(sffz) === 1 ? "不分装" : "分装";
}

export function specificationMl(spec) {
  if (!spec) return "";
  try {
    const obj = typeof spec === "string" ? JSON.parse(spec) : spec;
    return obj && obj.ml ? obj.ml + "ml" : "";
  } catch (e) {
    return "";
  }
}

/** 收货/回寄地址：兼容 JSON 对象串与纯文本 */
export function formatAddressText(raw) {
  if (raw == null || raw === "") return "";
  let text = String(raw).trim();
  if (!text) return "";
  if (text.startsWith('"')) {
    try {
      const unwrapped = JSON.parse(text);
      if (typeof unwrapped === "string") {
        text = unwrapped.trim();
      }
    } catch (e) {
      /* keep text */
    }
  }
  if (!(text.startsWith("{") && text.endsWith("}"))) return text;
  try {
    let o = JSON.parse(text);
    if (typeof o === "string") {
      const inner = String(o).trim();
      if (inner.startsWith("{")) {
        o = JSON.parse(inner);
      } else {
        return inner;
      }
    }
    if (!o || typeof o !== "object") return text;
    if (o.address && typeof o.address === "object") {
      o = o.address;
    } else if (typeof o.address === "string" && o.address.trim().startsWith("{")) {
      try {
        o = JSON.parse(o.address);
      } catch (e) {
        /* keep o */
      }
    }
    const pick = (...keys) => {
      for (const k of keys) {
        const v = o[k];
        if (v != null && String(v).trim()) return String(v).trim();
      }
      return "";
    };
    const mergeStreetDetail = () => {
      const street = pick("street", "town");
      let detail = pick("detail", "detailAddress", "addressDetail", "addr");
      if (street && (!detail || detail.indexOf(street) < 0)) {
        detail = detail ? street + detail : street;
      }
      return detail;
    };
    if (o.areaStr) {
      return [o.areaStr, mergeStreetDetail()].filter(Boolean).join("");
    }
    const province = pick("province", "provinceName");
    const city = pick("city", "cityName");
    let district = "";
    if (Array.isArray(o.area)) {
      district = o.area.map((x) => String(x || "").trim()).filter(Boolean).join("");
    } else {
      district = pick("area", "district", "districtName", "county", "countyName");
    }
    const detail = mergeStreetDetail();
    const region = [province, city, district].filter(Boolean).join("");
    return region + detail || text;
  } catch (e) {
    return text;
  }
}

export function formatReceiverLine(row) {
  if (!row) return "—";
  const name = (row.receiverName || "").trim();
  const phone = (row.receiverPhone || "").trim();
  const addr = formatAddressText(row.receiverAddress);
  const parts = [name, phone, addr].filter(Boolean);
  return parts.length ? parts.join("，") : "—";
}

export { platformInspectionTypeLabel };



// WEBPACK FOOTER //
// ./src/util/inspectionJobDisplay.js